import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FullDate } from '../../../../components/Date/FullDate'
import { CustomBtn } from '../../../../components/button/button'
import { Input } from '../../../../components/input/input'
import { Main } from '../../../../constant'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import CustomTable from '../../../../components/table/SimpleTable'
import { ShowLoader } from '../../../../redux/actions/loader'

function ReceiveFees(studentDetails) {
    //console.log(studentDetails)
    const [data, setData] = useState(Main().Fee);
    const [getfilterdata, setGetfilterdata] = useState(data.inputs.filter((item) => item.feildtype !== 'label'));
    const [initialInputValues, setInitialInputValues] = useState(Object.fromEntries(
      getfilterdata
        .map((item) => [item.name, ''])
    ));
    const [inputValues, setInputValues] = useState({ Date: dayjs().format('MMMM YYYY'), ...initialInputValues });
    const [amount, setAmount] = useState('');
    const [feesPay, setFeesPay] = useState('');
  const dispatch = useDispatch();
  const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;
  const url = useSelector((state) => state.Api);
  const [recordInserted, setRecordInserted] = useState(false);
  const [feesForMonth, setFeesFormMonth] = useState(0);
  const [numberOfDays, setNumberOfDays] = useState(0);
  const [feesForNumberOfDays, setFeesForNumberOfDays] = useState(0);
  const showlatefee = useSelector((state) => state.Api.showlatefee);
  const [dues, setDues] = useState(studentDetails?.studentDetails?.status?.dues - studentDetails?.studentDetails?.status?.paid);
       
  const calculateFees = () => {
    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let feesForDays = 0;
    const daysInCurrentMonth = currentDate.daysInMonth();

    if (inputValues.DateFrom) { // Check if DateFrom is falsy (undefined or empty)
      const startDate = parseInt(inputValues.DateFrom.split('-')[2], 10);
      const remainingDays = daysInCurrentMonth - (startDate - 1);
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      setNumberOfDays(remainingDays);
    } else {
      const remainingDays = daysInCurrentMonth - currentDate.date();
      feesForDays = (amount / daysInCurrentMonth) * remainingDays;
      // If you need to set the number of days for the current date, uncomment the line below
      setNumberOfDays(remainingDays);
    }

    // Ensure you're only setting state when necessary to avoid loops
    setFeesForNumberOfDays(feesForDays.toFixed(2));
    setFeesFormMonth(currentDate.month() + 1);

  }

  useEffect(() => {
    calculateFees()
  }, [amount, inputValues, dues, feesPay])

  const ChangeDate = (e) => {
    // //console.log(`${e.$y}-${e.$M}-${e.$D}`)
    //console.log(`${e.$y}-${e.$M + 1}-${e.$D}`)
    setInputValues((prevValues) => ({
      ...prevValues,
      DateFrom: `${e.$y}-${e.$M + 1}-${e.$D}`,
    }));
    calculateFees()
  }
  function receivedFees(e) {
    e.preventDefault();

    const timestamp = window.Date.now(); // You can also just use Date.now()
    const currentDate = dayjs(timestamp); // Use dayjs to get the current date
    let fetchTodayDate = ''
    const formattedDate = `${currentDate.year()}-${currentDate.month() + 1}-${currentDate.date()}`;
    fetchTodayDate = formattedDate
    const payload = {
      RollNum: studentDetails?.studentDetails?.StudentDetails?.RollNum, Fees: feesPay, FeesTypeSrn: studentDetails?.studentDetails?.status?.FeesTypeSrn,
      DateFrom: fetchTodayDate, Month: feesForMonth,
    }
    //console.log(studentDetails?.studentDetails?.StudentDetails?.RollNum)
    //console.log(payload)
    // setDues(1000000)
    // setFeesPay('') 
    // return false
    try {
      dispatch(ShowLoader('1'))
      axios.post(url.transportFeesReceived, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      })
        .then((res) => {
          if (res.status === 200) {
            dispatch(ShowLoader('0'))
            // //console.log(res.data.result);
            // setSuggestions(res.data.message);
            setRecordInserted(true)
            setFeesForNumberOfDays(0)
            let dues = res.data?.result?.reduce((acc, item) => acc + item.Fees, 0) || 0;
            let paid = res.data?.result?.reduce((acc, item) => acc + item.paidFees, 0) || 0;
            // res.data.status.dues = dues
            // res.data.status.paid = paid
            //console.log(dues - paid)
            setDues(dues - paid)
            setFeesPay('')
          }
        })
        .catch((err) => {
          dispatch(ShowLoader('0'))
          //console.error(err); // Log the error response for debugging
        });
    } catch (err) {
      dispatch(ShowLoader('0'))
      //console.error(err);
    }
  }
    return (
        <>
            {studentDetails?.studentDetails?.status?.TransportFacility == 'No'?
            <Grid>Please Enroll In Transport {studentDetails?.studentDetails?.StudentDetails?.Name_P}</Grid>  
          :
          <form onSubmit={receivedFees}>
                    <Grid>
                      <Typography sx={{ color: 'blue' }} variant='b'>
                        Monthly Fees: {studentDetails?.studentDetails?.status?.ActualFees}
                      </Typography>
                      <br/>
                      <Typography sx={{ color: 'blue' }} variant='b'>
                        Date Start: {studentDetails?.studentDetails?.status?.startDate}
                      </Typography>
                      <br />
                      <Typography sx={{ color: 'red' }} variant='b'>
                        Dues: {dues}
                      </Typography>
                      <br />
                      {/* <FullDate throwfullevent={ChangeDate} name='endDate' /> */}

                      <Input sx={{ margin: '0px 0px 0px' }} onChange={(event) => setFeesPay(event.target.value)} name="Amount" placeholder='Fees' />

                      <br />
                      <br />
                      {/* <textarea sx={{ margin: '15px 0px 0px' }} rows="4" cols="74" onChange={(event) => setComments(event.target.value)} name="comments" placeholder='Comments' ></textarea> */}

                      {/* <br/>{amount == ''? 'true' : 'false'} */}
                      <CustomBtn disabled={true} data='Fees Received' />
                    </Grid>
                  </form>
          }

  <br/>
  <br/>
  <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', width:'117%' }}>
  {
                        studentDetails?.studentDetails && studentDetails?.studentDetails?.result?.length != 0 && studentDetails?.studentDetails?.result != null && studentDetails?.studentDetails?.result != undefined  ?
                        <CustomTable data={studentDetails?.studentDetails?.result} />            
                        :
                        null
                    }
          </Box>
        </>
    )
}

export default ReceiveFees
